import { z } from 'zod';

const NewDevelopmentChargeSchema = z.object({
  id: z.number(),
  name: z.literal('NEW_DEVELOPMENT_CHARGE'),
  brand: z.literal('EXETEL'),
  prices: z
    .array(
      z.object({
        id: z.number(),
        description: z.string(),
        amount: z.number(),
      })
    )
    .nonempty(),
});

export type NewDevelopmentCharge = z.infer<typeof NewDevelopmentChargeSchema>;

export const FeaturesResponseSchema = z
  .array(NewDevelopmentChargeSchema)
  .nonempty();
